module.exports = __webpack_public_path__ + "img/halon_no.e756eabd.png";